import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex justify-flex-start items-center" }
const _hoisted_2 = { class: "mr-4 flex items-center justify-center h-12 w-12 rounded-full bg-primary-color-100" }
const _hoisted_3 = { class: "text-primary-color-600" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "flex justify-end" }

import GgmsModal from "@/components/GgmsModal.vue"
import { computed, ref } from "vue"
import { DocumentTextIcon } from "@heroicons/vue/outline"
import { DialogTitle } from "@headlessui/vue"
import { Template } from "@/shared/models/template"
import GgmsButton from "@/components/GgmsButton.vue"
import TemplateSelectStep from "./TemplateSelectStep.vue"
import TemplatePreviewStep from "./TemplatePreviewStep.vue"

interface Props {
    open: boolean
    templateTitle: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MessageTemplatesModal',
  props: {
    open: { type: Boolean },
    templateTitle: {}
  },
  emits: ["closeModal", "update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit
const props = __props

const currentStepIndex = ref(0)

const steps = [
    // choose template step
    {
        component: TemplateSelectStep,
        value: { templateType: setTemplateTitle() } as Template,
        handleUpdate: (value: Template) => {
            steps[0].value = value
            steps[1].value = value
            currentStepIndex.value += 1
        },
        resolveTitle: () => "Preview",
    },
    // preview step
    {
        component: TemplatePreviewStep,
        value: {} as Template,
        handleUpdate: (value: Template) => {
            steps[1].value = value
            return
        },
        resolveTitle: () => "",
    },
]

const currentStep = computed(() => steps[currentStepIndex.value])
function applyTemplate() {
    emit("update:modelValue", currentStep.value.value)
    closeModal()
}

function closeModal() {
    currentStepIndex.value = 0
    steps.forEach((step) => (step.value = {} as Template))
    steps[0].value = { templateType: setTemplateTitle() } as Template
    emit("closeModal")
}

function setTemplateTitle() {
    if (props.templateTitle === "Text Message") {
        return "sms"
    }
    return "email"
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(GgmsModal, {
    open: props.open,
    onCloseModal: closeModal
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(DocumentTextIcon), {
            class: "h-6 w-6 text-primary-color-600",
            "aria-hidden": "true"
          })
        ]),
        _createVNode(_unref(DialogTitle), {
          as: "h3",
          class: "text-lg leading-6 font-medium"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("span", {
                class: "last:text-black cursor-pointer last:cursor-auto",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (currentStepIndex.value = 0))
              }, _toDisplayString(_ctx.templateTitle) + " Templates", 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentStepIndex.value, (number, stepIndex) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: number,
                  class: "last:text-black ml-2 cursor-pointer last:cursor-auto",
                  onClick: ($event: any) => (currentStepIndex.value = number)
                }, "> " + _toDisplayString(steps[stepIndex].resolveTitle()), 9, _hoisted_4))
              }), 128))
            ])
          ]),
          _: 1
        })
      ])
    ]),
    under: _withCtx(() => [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(GgmsButton, {
          styleType: "secondary",
          onClick: closeModal
        }, {
          default: _withCtx(() => [
            _createTextVNode("Cancel")
          ]),
          _: 1
        }),
        _createVNode(GgmsButton, {
          class: "ml-3",
          onClick: applyTemplate,
          disabled: currentStepIndex.value !== 1
        }, {
          default: _withCtx(() => [
            _createTextVNode("Done")
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("form", {
        class: "space-y-6",
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
      }, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(currentStep.value.component), {
          key: currentStepIndex.value,
          "model-value": currentStep.value.value,
          "onUpdate:modelValue": currentStep.value.handleUpdate,
          category: steps[0].value
        }, null, 8, ["model-value", "onUpdate:modelValue", "category"]))
      ], 32)
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})